function cleanText(value) {
  return typeof value === 'string' ? value.trim() : '';
}

function getPhoneNumberValue(value) {
  if (typeof value === 'string') {
    return { number: cleanText(value), label: '' };
  }
  if (!value || typeof value !== 'object') {
    return { number: '', label: '' };
  }
  return {
    number: cleanText(value.number || value.value || value.phoneNumber || ''),
    label: cleanText(value.label || ''),
  };
}

export function formatPhoneNumber(value, labelSeparator = ': ') {
  if (typeof value === 'string') {
    return value;
  }
  const { number, label } = getPhoneNumberValue(value);
  if (!number) {
    return '';
  }
  return label ? `${label}${labelSeparator}${number}` : number;
}

export default getPhoneNumberValue;
